import { Box } from "@mui/joy";
import { memo, useState } from "react";
import { theme } from "styles/theme";
import CustomTypography from "../../../common/CustomTypography";

interface HelpCellProps {
  label: string;
  helpText: string;
}

function HelpCell({ label, helpText }: HelpCellProps) {
  const [isOpen, setIsOpen] = useState(false);

  const handleClick = () => {
    setIsOpen(true);
  };

  return (
    <Box
      sx={{
        ml: "2px",
        display: "inline-block",
      }}
    >
      {!isOpen ? (
        <CustomTypography
          level="body-sm"
          sx={{
            color: theme.vars.palette.Content.Weak,
            textDecoration: "underline",
            cursor: "pointer",
            fontWeight: 400,
            textUnderlineOffset: "2px",
            textDecorationColor: theme.vars.palette.Content.Weak,
          }}
          onClick={handleClick}
        >
          {label}
        </CustomTypography>
      ) : (
        <CustomTypography
          level="body-sm"
          sx={{
            mb: 0.5,
            color: theme.vars.palette.Content.Medium,
            fontWeight: 400,
          }}
        >
          {helpText}
        </CustomTypography>
      )}
    </Box>
  );
}

export default memo(HelpCell);